import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { modalStyle } from '.';
import Typography from '@mui/material/Typography';

const CLOSEOUT_REASONS = [
  '',
  'Seen',
  'Missed',
  'Lost Contact',
  'Cancelled - Refused',
  'Cancelled - Intent to Reschedule',
];

const UNROUTEABLE_REASONS = ['', 'Unrouteable'];

const CloseOutModal = ({
  handleCloseOutClick,
  isCloseOutModalOpen,
  setIsCloseOutModalOpen,
  isUnrouteable,
}) => {
  const REASONS = isUnrouteable ? UNROUTEABLE_REASONS : CLOSEOUT_REASONS;
  const [closeOutReason, setCloseOutReason] = useState(REASONS[1]);
  return (
    <Modal
      open={isCloseOutModalOpen}
      onClose={() => {
        setIsCloseOutModalOpen(false);
      }}
      aria-labelledby='closeout-alert-modal'
      aria-describedby='modal-to-closeout-alerts'
    >
      <Box sx={{ ...modalStyle, width: 400 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <FormControl>
            <InputLabel id='closeout-label'>Select a Reason</InputLabel>
            <Select
              labelId='closeout-label'
              id='closeout'
              value={closeOutReason}
              label='closeout'
              onChange={(e) => setCloseOutReason(e.target.value)}
            >
              {REASONS.map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                >
                  {!option ? <em>None</em> : option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            onClick={() => {
              handleCloseOutClick(closeOutReason || null);
            }}
          >
            Done
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CloseOutModal;
